import { render, staticRenderFns } from "./SubfolderSearch.vue?vue&type=template&id=128de172&scoped=true&"
import script from "./SubfolderSearch.vue?vue&type=script&lang=js&"
export * from "./SubfolderSearch.vue?vue&type=script&lang=js&"
import style0 from "./SubfolderSearch.vue?vue&type=style&index=0&id=128de172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128de172",
  null
  
)

export default component.exports